import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from './assets/Fraport_Logo_Slovenija.svg'


const _hoisted_1 = { class: "h-screen bg-background flex flex-col" }
const _hoisted_2 = { class: "flex-1 flex flex-col overflow-hidden" }
const _hoisted_3 = { class: "relative z-10 h-full flex items-center justify-center" }
const _hoisted_4 = { class: "max-w-7xl w-full px-4 sm:px-6 lg:px-8" }
const _hoisted_5 = { class: "flex items-center justify-center" }
const _hoisted_6 = { class: "flex items-center max-w-6xl w-full" }
const _hoisted_7 = { class: "w-1/2 flex justify-center" }
const _hoisted_8 = { class: "w-full max-w-md" }
const _hoisted_9 = {
  key: 1,
  class: "flex h-full"
}
const _hoisted_10 = { class: "flex-1 overflow-auto p-6 transition-all duration-300 bg-gray-50" }
const _hoisted_11 = {
  key: 0,
  class: "fixed top-4 right-4 bg-blue-100 text-blue-800 px-4 py-2 rounded-md shadow-md z-50"
}
const _hoisted_12 = {
  key: 1,
  class: "flex flex-col items-center justify-center h-full"
}
const _hoisted_13 = { class: "bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-4 max-w-md" }
const _hoisted_14 = { class: "flex" }
const _hoisted_15 = { class: "ml-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConnectionResetHandler = _resolveComponent("ConnectionResetHandler")!
  const _component_LoginForm = _resolveComponent("LoginForm")!
  const _component_RegisterForm = _resolveComponent("RegisterForm")!
  const _component_SideNav = _resolveComponent("SideNav")!
  const _component_Dashboard = _resolveComponent("Dashboard")!
  const _component_EmailGenerator = _resolveComponent("EmailGenerator")!
  const _component_UserSettings = _resolveComponent("UserSettings")!
  const _component_SupabaseTest = _resolveComponent("SupabaseTest")!
  const _component_StorageTest = _resolveComponent("StorageTest")!
  const _component_ForecastingPCO = _resolveComponent("ForecastingPCO")!
  const _component_Chatbot = _resolveComponent("Chatbot")!
  const _component_Administration = _resolveComponent("Administration")!
  const _component_ForecastingPlanners = _resolveComponent("ForecastingPlanners")!
  const _component_TemplateStorageExample = _resolveComponent("TemplateStorageExample")!
  const _component_KnowledgebaseUpload = _resolveComponent("KnowledgebaseUpload")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ConnectionResetHandler),
    _createElementVNode("main", _hoisted_2, [
      (!_ctx.isAuthenticated)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "relative h-full bg-cover bg-center",
            style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/airport-background.jpg')})` })
          }, [
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "absolute inset-0 backdrop-blur-lg bg-black/40" }, null, -1)),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"w-1/2 pr-8\"><div class=\"mb-6\"><img src=\"" + _imports_0 + "\" alt=\"Fraport Slovenija Logo\" class=\"h-24 w-auto invert brightness-0 filter\"></div><h1 class=\"text-4xl font-bold text-white mb-4 text-shadow\">Welcome to Fraport Insights - Your Intelligent Airport Management Solution</h1><p class=\"text-xl text-white text-shadow\">Streamline airport operations with advanced forecasting and AI-powered workflow optimization.</p></div>", 1)),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        (_ctx.showLoginForm)
                          ? (_openBlock(), _createBlock(_component_LoginForm, {
                              key: 0,
                              onLoginSuccess: _ctx.handleLoginSuccess,
                              onSwitchToRegister: _cache[0] || (_cache[0] = ($event: any) => {_ctx.showRegisterForm = true; _ctx.showLoginForm = false})
                            }, null, 8, ["onLoginSuccess"]))
                          : (_openBlock(), _createBlock(_component_RegisterForm, {
                              key: 1,
                              onRegisterSuccess: _ctx.handleRegisterSuccess,
                              onSwitchToLogin: _cache[1] || (_cache[1] = ($event: any) => {_ctx.showRegisterForm = false; _ctx.showLoginForm = true})
                            }, null, 8, ["onRegisterSuccess"]))
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ], 4))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(_component_SideNav, {
              activeItem: _ctx.activeNavItem,
              userData: _ctx.userData,
              onNavigate: _ctx.handleNavigation,
              onLogout: _ctx.logout,
              onToggleCollapse: _ctx.handleSideNavCollapse
            }, null, 8, ["activeItem", "userData", "onNavigate", "onLogout", "onToggleCollapse"]),
            _createElementVNode("div", _hoisted_10, [
              (_ctx.isSessionRefreshing)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, _cache[5] || (_cache[5] = [
                    _createElementVNode("span", { class: "inline-block mr-2" }, [
                      _createElementVNode("svg", {
                        class: "animate-spin h-5 w-5 text-blue-600",
                        xmlns: "http://www.w3.org/2000/svg",
                        fill: "none",
                        viewBox: "0 0 24 24"
                      }, [
                        _createElementVNode("circle", {
                          class: "opacity-25",
                          cx: "12",
                          cy: "12",
                          r: "10",
                          stroke: "currentColor",
                          "stroke-width": "4"
                        }),
                        _createElementVNode("path", {
                          class: "opacity-75",
                          fill: "currentColor",
                          d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        })
                      ])
                    ], -1),
                    _createTextVNode(" Refreshing session... ")
                  ])))
                : _createCommentVNode("", true),
              (_ctx.isAuthenticated && !_ctx.isSessionValid && !_ctx.isSessionRefreshing)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "flex-shrink-0" }, [
                          _createElementVNode("svg", {
                            class: "h-5 w-5 text-yellow-400",
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 20 20",
                            fill: "currentColor"
                          }, [
                            _createElementVNode("path", {
                              "fill-rule": "evenodd",
                              d: "M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z",
                              "clip-rule": "evenodd"
                            })
                          ])
                        ], -1)),
                        _createElementVNode("div", _hoisted_15, [
                          _cache[6] || (_cache[6] = _createElementVNode("p", { class: "text-sm text-yellow-700" }, " Your session appears to be invalid. Reload the page or click retry to refresh... ", -1)),
                          _createElementVNode("button", {
                            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.validateSession && _ctx.validateSession(...args))),
                            class: "mt-2 px-4 py-2 bg-yellow-100 hover:bg-yellow-200 text-yellow-800 rounded-md text-sm font-medium transition-colors"
                          }, " Retry ")
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isSessionValid)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    (_ctx.activeNavItem === 'dashboard')
                      ? (_openBlock(), _createBlock(_component_Dashboard, { key: 0 }))
                      : (_ctx.activeNavItem === 'email-generator')
                        ? (_openBlock(), _createBlock(_component_EmailGenerator, { key: 1 }))
                        : (_ctx.activeNavItem === 'user-settings')
                          ? (_openBlock(), _createBlock(_component_UserSettings, {
                              key: 2,
                              userData: {
                ..._ctx.userData,
                role: _ctx.userData.system_role === 'ADMIN' ? 'Administrator' : 'User',
                business_role: _ctx.userData.business_role as BusinessRole
              },
                              onUpdateUserData: _ctx.updateUserData
                            }, null, 8, ["userData", "onUpdateUserData"]))
                          : (_ctx.activeNavItem === 'supabase-test')
                            ? (_openBlock(), _createBlock(_component_SupabaseTest, { key: 3 }))
                            : (_ctx.activeNavItem === 'storage-test')
                              ? (_openBlock(), _createBlock(_component_StorageTest, { key: 4 }))
                              : (_ctx.activeNavItem === 'forecasting-pco')
                                ? (_openBlock(), _createBlock(_component_ForecastingPCO, {
                                    key: 5,
                                    userData: _ctx.userData
                                  }, null, 8, ["userData"]))
                                : (_ctx.activeNavItem === 'chatbot')
                                  ? (_openBlock(), _createBlock(_component_Chatbot, {
                                      key: 6,
                                      userData: _ctx.userData
                                    }, null, 8, ["userData"]))
                                  : (_ctx.activeNavItem === 'administration')
                                    ? (_openBlock(), _createBlock(_component_Administration, {
                                        key: 7,
                                        initialView: _ctx.administrationSubView
                                      }, null, 8, ["initialView"]))
                                    : (_ctx.userData && _ctx.activeNavItem === 'forecasting-planners')
                                      ? (_openBlock(), _createBlock(_component_ForecastingPlanners, {
                                          key: 8,
                                          userData: _ctx.userData
                                        }, null, 8, ["userData"]))
                                      : (_ctx.activeNavItem === 'template-storage')
                                        ? (_openBlock(), _createBlock(_component_TemplateStorageExample, { key: 9 }))
                                        : (_ctx.activeNavItem === 'knowledgebase-upload')
                                          ? (_openBlock(), _createBlock(_component_KnowledgebaseUpload, { key: 10 }))
                                          : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true)
            ])
          ]))
    ])
  ]))
}